import { useFetch } from '@/hooks/useFetch';
import type { ErrorResponse } from '@/types/apiTypes';
import { useMutation } from '@tanstack/react-query';

export const useDeleteLoyaltyProgramMutation = () => {
  const { doFetch: deleteLoyaltyProgram } = useFetch<void, void>();
  return useMutation<void, ErrorResponse<unknown>, { clientId: number, lpId: number }>({
    mutationFn: ({ clientId, lpId }: { clientId: number, lpId: number }) => deleteLoyaltyProgram(`/api/client-details/${clientId}/loyalty-program/${lpId}`, { method: 'DELETE' }),
  });
};